<template>
  <v-container>
    <v-layout wrap>
      <v-flex
        v-for="project in projectsList"
        :key="project.id"
        align-content-start
        my-2
        mx-2
        shrink
      >
        <v-card width="330" height="100%" class="d-flex flex-column">
          <v-img
            :src="project.backgroundImage || '/missing_image.webp'"
            :lazy-src="project.backgroundImage || '/missing_image.webp'"
            height="200px"
            max-height="200px"
          ></v-img>

          <v-card-title>
            <v-avatar v-if="project.logo" size="25" class="mr-2" tile>
              <v-img
                v-if="project.logo"
                :src="project.logo"
                :lazy-src="project.logo"
                contain
              ></v-img>
              <v-icon v-else>mdi-code-tags</v-icon>
            </v-avatar>
            <h3>{{ project.name }}</h3>
          </v-card-title>

          <v-card-text>
            {{ project.description }}
          </v-card-text>

          <v-card-actions class="mt-auto">
            <v-btn
              color="orange"
              :to="{
                name: 'project',
                params: {
                  id: project.id,
                },
              }"
            >
              View
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Gallery",
  computed: {
    ...mapGetters("galleryProjects/", { projectsList: "PROJECTS_LIST" }),
  },
  methods: {
    ...mapActions("galleryProjects/", ["GET_PROJECTS"]),
  },
  created() {
    this.GET_PROJECTS();
  },
};
</script>
